var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBasket = function SvgIconBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.738 2.719c.086-.255-.08-.541-.371-.639-.29-.098-.596.029-.682.284L6.6 8.55c-.086.255.08.54.37.639.292.098.597-.03.683-.284zM12.5 13a.5.5 0 0 0-1 0v6a.5.5 0 1 0 1 0zM16.542 12.627a.5.5 0 0 1 .392.588l-1.11 5.555a.5.5 0 0 1-.981-.196l1.11-5.555a.5.5 0 0 1 .59-.393M8.046 13.019a.5.5 0 1 0-.98.196l1.11 5.555a.5.5 0 1 0 .98-.196z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.704 12.535A2 2 0 0 1 4.631 10H19.37a2 2 0 0 1 1.927 2.535l-2.223 8A2 2 0 0 1 17.146 22H6.853a2 2 0 0 1-1.927-1.465zM4.631 11H19.37a1 1 0 0 1 .963 1.267l-2.222 8a1 1 0 0 1-.964.733H6.853a1 1 0 0 1-.963-.733l-2.222-8A1 1 0 0 1 4.63 11",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.748 2.08c-.29.098-.457.384-.37.639l2.084 6.186c.086.255.392.382.682.284s.457-.384.371-.639L15.43 2.364c-.086-.255-.39-.382-.682-.284"
  })));
};
export default SvgIconBasket;